export interface FieldsItemModel {
  img: any;
  title: string;
  cols: string;
  ref: string;
  className?: string;
}

export const fieldsItems: FieldsItemModel[] = [
  {
    img: () => require('@shared/assets/Science_BG.svg'),
    title: 'Science',
    cols: '3',
    ref: 'science'
  },
  {
    img: () => require('@shared/assets/Technology_BG.svg'),
    title: 'Technology',
    cols: '3',
    ref: 'technology'
  },
  {
    img: () => require('@shared/assets/Reading_BG.svg'),
    title: 'Reading',
    cols: '6',
    ref: 'reading'
  },
  {
    img: () => require('@shared/assets/Engineering_BG.svg'),
    title: 'Engineering',
    cols: '6',
    ref: 'engineering',
    className: 'pr-7'
  },
  {
    img: () => require('@shared/assets/Art_BG.svg'),
    title: 'Art & Music',
    cols: '3',
    ref: 'art'
  },
  {
    img: () => require('@shared/assets/Math_BG.svg'),
    title: 'Math',
    cols: '3',
    ref: 'math'
  },
  {
    img: () => require('@shared/assets/SEL_BG.svg'),
    title: 'Social Emotional Learning (SEL)',
    cols: '12',
    ref: 'sel',
    className: 'pr-7'
  }
];
